var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-page-section',{attrs:{"padded":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Usage")]},proxy:true},{key:"body",fn:function(){return [_c('v-stats',{attrs:{"stats":_vm.stats}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }